import { gql } from '@apollo/client';

export * from './escrowTerminationAccept.mutation.generated';

export const ESCROW_TERMINATION_ACCEPT = gql`
  mutation escrowTerminationAccept($escrowTerminationId: ID!) {
    escrowTerminationAccept(input: { escrowTerminationId: $escrowTerminationId }) {
      success
      errors
    }
  }
`;
